import { Component, type ReactNode } from 'react';

/** Shows an actionable message instead of a blank screen if rendering fails. Unsaved work stays in local recovery storage. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  componentDidCatch(error: Error) {
    console.error('Calendar Studio crashed', error);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="page">
        <div className="card pad col">
          <h1>Something went wrong on this screen</h1>
          <p className="muted">Your last changes are kept in this browser and will be offered for recovery when you reopen the project.</p>
          <pre className="mono" style={{ whiteSpace: 'pre-wrap', background: 'var(--panel-2)', padding: 10, borderRadius: 6 }}>{this.state.error.message}</pre>
          <div className="row"><button className="btn primary" onClick={() => location.reload()}>Reload</button><button className="btn" onClick={() => { location.href = '/'; }}>Back to projects</button></div>
        </div>
      </div>
    );
  }
}
